import React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import Link from 'ha/ui/next/Link';
import Img from 'ha/ui/next/Img';
import Track from 'ha/components/track/SmartTrack';
import haLogo from 'img-src/logos/housing-anywhere-logo.svg';

export const NavBarLogo: React.FC<IntlProps> = ({ intl: { urlResolver } }) => (
  <Track name="Clicked Logo in header" type="icon">
    <Link to={urlResolver.getHomeUrl()} data-test-locator="HA Logo">
      <Img src={haLogo} alt="HousingAnywhere" />
    </Link>
  </Track>
);

export default withIntl(NavBarLogo);
